<template>
  <a-config-provider :locale="locale">
    <a-watermark :content="markvalue">
      <router-view v-if="loaded" />
    </a-watermark>
      
    </a-config-provider>
</template>
<script >
import { defineComponent, reactive } from 'vue';
import { message } from 'ant-design-vue';
import zhCN from "ant-design-vue/es/locale/zh_CN";

import { useRouter, useRoute } from 'vue-router'
import request from './utils/request'
import store from '@/store'

export default defineComponent({
  data(){
    return {
      locale: zhCN,
      loaded: false,
      userData: {},
      agreementVisible: true,
    }
  },
  components:{
    
  },
  methods:{
    onAgreement: function(){
      location.reload()
    }
  },
  computed:{
    markvalue : () => {
      if (store && store.state.user.user_id > 0) {
        return `${store.state.user.nickname}-${store.state.user.user_id}`
      }
      
    },
  },
  mounted(){
    let router = useRouter()
    let route = useRoute()
    request.post(
      '/api/account/auth'
    ).then((res) => {
      if (res.data) {
        store.commit("setLogin", res.data)
      } else {
        router.push({
          path: "/login"
        })
      }
      this.loaded = true
      
    }).catch((res) => {
      this.loaded = true
      console.log("未登录", res)
      router.push({
        path: "/login"
      })
    })
  },
  setup() {
    return {
      
    };
  },
});
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

#nav {

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.notice-icon {
  width: 18px;
  height: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #000;
  border-radius: 50%;
  margin-left: 5px;
  cursor: pointer;
}

.stats-table {
  
}
.stats-table legend {
  font-size: 20px;


}
.stats-table th {
  border: 1px solid #1e5530;
  background: #1e5530;
  color: #FFF;
}
.stats-table td {
  border: 1px solid #BBB;
  padding: 4px 8px;
}
.stats-table tr td:first-child {
  font-weight: bold;
}
.stats-table tr:hover {
  background-color: #3c3c3ce1 !important;
  color: #FFF;
}
.stats-table tr:nth-child(even) {
  background-color: #f4f4f4e1;
}

.green-btn {
  background-color: #21b753; /* 自定义背景颜色 */
  border-color: #109d40; /* 自定义边框颜色 */
  color: #ffffff; /* 自定义文字颜色 */
}

.green-btn:hover {
  background-color: #4df083; /* 自定义背景颜色 */
  border-color: #1dcb57; /* 自定义边框颜色 */
  color: #ffffff; /* 自定义文字颜色 */
}

.form-section-title {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
.ant-form-item{
  // margin: 10px auto;
  margin-top:10px;
  margin-bottom:10px;
}
</style>
